import { render, staticRenderFns } from "./MyProfile.vue?vue&type=template&id=8d8486b0&scoped=true"
import script from "./MyProfile.vue?vue&type=script&lang=js"
export * from "./MyProfile.vue?vue&type=script&lang=js"
import style0 from "./MyProfile.vue?vue&type=style&index=0&id=8d8486b0&prod&lang=css"
import style1 from "./MyProfile.vue?vue&type=style&index=1&id=8d8486b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8486b0",
  null
  
)

export default component.exports